import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { debounce } from "@universityofmaryland/web-utilities-library/performance";
import { createCompositeMediaCaption } from "../elements/caption.js";
import "@universityofmaryland/web-styles-library";
import { createLayoutImageContainer } from "../../../layout/image.js";
const CreateMediaWithCaption = (props) => {
  const { caption, image, isThemeDark } = props;
  const hasCaption = caption && caption !== null;
  const createImage = () => {
    if (!image) {
      console.warn("CreateMediaWithCaption: No image provided");
      return null;
    }
    return createLayoutImageContainer({ image, showCaption: true });
  };
  const createCaption = () => {
    if (!hasCaption) {
      console.warn("CreateMediaWithCaption: No caption provided");
      return null;
    }
    const captionContainer = createCompositeMediaCaption.CreateElement({ caption, isThemeDark });
    captionContainer.style.display = "none";
    return captionContainer;
  };
  const imageElement = createImage();
  const captionElement = createCaption();
  const children = [imageElement, captionElement].filter((child) => child != null);
  const objectModel = new ElementBuilder().withClassName("element-media-caption-container").withStyles({
    element: {
      display: "flex",
      flexDirection: "column",
      paddingBottom: token.spacing.sm,
      maxWidth: "100%"
    }
  }).withChildren(...children).build();
  const containerBuilder = new ElementBuilder().withClassName("element-media-with-caption-container").withStyles({
    element: {
      display: "inline-block",
      maxWidth: "100%"
    }
  });
  if (image || hasCaption) {
    containerBuilder.withChild(objectModel);
  }
  const containerModel = containerBuilder.build();
  const objectContainer = objectModel.element;
  const sizeCaption = () => {
    if (!imageElement || !captionElement) return;
    captionElement.style.width = `${imageElement.element.offsetWidth}px`;
    captionElement.style.display = `block`;
  };
  const load = () => {
    const checkSizing = () => {
      const captionElement2 = objectContainer.querySelector(
        `.${createCompositeMediaCaption.Elements.container}`
      );
      if (captionElement2) {
        captionElement2.style.opacity = `1`;
      }
    };
    if (!image) {
      console.warn("CreateMediaWithCaption: No image provided");
      return null;
    }
    image.addEventListener("load", () => {
      checkSizing();
      setTimeout(() => {
        checkSizing();
      }, 500);
    });
  };
  window.addEventListener(
    "resize",
    debounce(() => {
      sizeCaption();
    }, 20)
  );
  setTimeout(() => {
    sizeCaption();
  }, 100);
  containerModel.styles += createCompositeMediaCaption.Styles;
  return {
    ...containerModel,
    events: {
      load
    }
  };
};
const createCompositeMediaInlineCaption = CreateMediaWithCaption;
export {
  createCompositeMediaInlineCaption
};
//# sourceMappingURL=caption.js.map
